// extracted by mini-css-extract-plugin
export default {"TextEditorContainer":"TextEditor_TextEditorContainer__MNj68"};